import React, { useContext, useEffect, useState } from 'react'
import { DRFdetailGet, DRFdetailsave } from '../../../services/drfDetail';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import LenderUgroService from '../.././../services/lender';
import { getFormattedDateFromString } from '../../../common/date';
import { Context } from '../../../config/store';
import AddDRFModal from './AddDRFModal';
import Modal from '../../../components/Modal';

import './drf.css'
import AddBtDataModal from './AddBtDataModal';
import Table from '../../../components/Common/Table';
import BtCaseColumns from './BtCaseColumns';
import TableNoRecords from '../../../components/Common/Table/TableNoRecords';

const DRF = ({ cl_lead_lender_status, selectedLender }) => {
    const { state } = useContext(Context);
    const leadId = useParams().id;
    const [response, setResponse] = useState(null)
    const [supResponse, setSupResponse] = useState(null)
    const [isSupDrf, setIsSupDrf] = useState(0)
    const [loader, setLoader] = useState(false)
    const [loading, setLoading] = useState(false)
    const [modalState, setModalState] = useState(false);
    const [showOldDRF, setShowOldDRF] = useState(false);
    const [transType, setTransType] = useState({});
    const [isBTCase, setIsBTCase] = useState(0)
    const [btBankCaseResponse, setBtBankCaseResponse] = useState([])
    const [btCustomerCaseResponse, setBtCustomerCaseResponse] = useState([])
    const [btModalState, setBtModalState] = useState(false)
    const [companyDetails, setCompanyDetails] = useState({})

    const checkHasPermission = (checkPermission) => {
        if (state.is_super_admin === 1) return true;
        const permission = state.permission.find(
            (permission) => permission === checkPermission
        );

        if (permission) return true;
        else return false;
    };

    const toggleModal = (type = false) => {
        if (type) {
            setShowOldDRF(true)
        } else {
            setShowOldDRF(false)
        }
        setModalState(!modalState);
    };
    const toggleBtModal = (type = false) => {
        setBtModalState(!btModalState);
    };

    const GetDrfDetail = async (leadId) => {
        setLoader(true)
        const response = await DRFdetailGet(leadId, selectedLender);
        if (response?.http?.code === 200) {
            setCompanyDetails(response?.data?.lead_detail)
            setResponse(response?.data?.lead_drf_detail);
            setSupResponse(response?.data?.supplier_drf_detail);
            setTransType(response?.data?.trans_types || {})
            setIsSupDrf(response?.data?.is_sup_drf)
            setIsBTCase(response?.data?.is_bt_case)
            let btdata = response?.data?.bt_drf_detail;
            let btBankData = [];
            let btCustomerData = [];
            (btdata || [])?.map((item) => {
                if (item?.disbursal_to == 1) {
                    btBankData.push(item)
                } else {
                    btCustomerData.push(item)
                }
            })
            setBtBankCaseResponse(btBankData);
            setBtCustomerCaseResponse(btCustomerData);
            setLoader(false)
        } else {
            setLoader(false)
            if (response?.http?.code == 400) {
                toast.error(response?.messages?.error?.others?.[0]);
            }
            else if (response?.http?.code == 422) {
                toast.error(response?.messages?.error?.others?.[0]);
            }
            setLoader(false)
        }
    }

    const saveDrfStatus = async (leadId) => {
        setLoading(true)
        let formData = new FormData();
        formData.append('is_machinery_sup', 1)

        await LenderUgroService.SaveDrfDetail({ formData, leadId, lenderId:selectedLender }).then((response) => {
            toast.success(response?.data?.messages?.success?.others[0])
            setLoading(false);
            GetDrfDetail(leadId);
        }).catch((err) => {
            toast.error(err?.response?.statusText)
            setLoading(false)
        });
    }

    const acc_types = {
        '01': 'Saving',
        '02': 'Current',
        '03': 'Cash',
        '04': 'CC',
    }

    const drfParser = (data) => {
        let parsed_data = {
            acc_name: data?.NAME,
            asset_amt: '',
            finance_amount: data?.AMOUNT,
            bank_name: data?.BANK_NAME,
            ifsc: data?.IFSC_CODE,
            bank_acc_id: data?.BANK_ACCOUNT_ID,
            txn_type: data?.TRANS_TYPE,
            date: data?.DRF_DATE,
            city: '',
            address: data?.LOCATION,
        };
        return parsed_data;
    }

    useEffect(() => {
        GetDrfDetail(leadId)
    }, [])

    return (
        <>
            {loader ? <div className='Tableloader' style={{ margin: "100px auto" }}></div> :
                <>
                    {(!supResponse && checkHasPermission('add-drf') && isSupDrf && [6,9,10,18,19,20].includes(cl_lead_lender_status?.id)) ?
                        <div className='mt-2'>
                            <div style={{ borderRadius: "5px", width: "100%", paddingBottom: "13px" }}>
                                <div className='' style={{ 'font-size': '16px', 'margin': '10px 0 0 10px' }}>Please confirm if the details shared are of the Machinery Supplier?</div>
                                <div style={{ 'float': 'right', 'margin-top': '-24px' }}>
                                    <button className='btn btn-custom' style={{ marginRight: '10px', float: 'left' }} onClick={() => toggleModal(true)}>Yes</button>
                                    <button className='btn btn-custom' style={{ marginRight: '450px' }} onClick={() => toggleModal(false)}>No</button>
                                    {modalState && (
                                        <AddDRFModal
                                            userType={state.userType}
                                            state={modalState}
                                            selectedLender={selectedLender}
                                            toggleModal={toggleModal}
                                            leadId={leadId}
                                            reloadTable={GetDrfDetail}
                                            isMachinerySup={showOldDRF ? 1 : 0}
                                            mstTransType={transType}
                                            data={showOldDRF ? drfParser(response) : supResponse}
                                        />
                                    )}
                                </div>
                            </div>
                        </div> : ''}
                    {response && !isBTCase &&
                        <div className='mt-2'>
                            <div style={{ borderRadius: "5px", width: "100%", border: "1px solid #CBCBCB" }}>
                                <div className='border p-2' style={{ backgroundColor: "#F8F8F8", borderRadius: "5px 5px 0 0 " }}>
                                    <h5>DRF Details</h5>
                                </div>
                                <div className='row p-2'>
                                    <div className='col-md-2'>
                                        <p className='detailsRightLabel'>{'ACCOUNT TYPE'}</p>
                                        <p className='detailsRightValue-drf'>{acc_types[response?.ACT_TYPE] ?? response?.ACT_TYPE}</p>
                                    </div>
                                    <div className='col-md-2'>
                                        <p className='detailsRightLabel'>{'DISBURSED AMOUNT'}</p>
                                        <p className='detailsRightValue-drf'>{response?.AMOUNT}</p>
                                    </div>
                                    <div className='col-md-2'>
                                        <p className='detailsRightLabel'>{'BANK ACCOUNT NUMBER'}</p>
                                        <p className='detailsRightValue-drf'>{response?.BANK_ACCOUNT_ID}</p>
                                    </div>
                                    <div className='col-md-3'>
                                        <p className='detailsRightLabel'>{'NAME'}</p>
                                        <p className='detailsRightValue-drf'> {response?.NAME}</p>
                                    </div>
                                    <div className='col-md-3'>
                                        <p className='detailsRightLabel'>{'BANK NAME'}</p>
                                        <p className='detailsRightValue-drf'> {response?.BANK_NAME}</p>
                                    </div>

                                    <div className='col-md-2 mt-3'>
                                        <p className='detailsRightLabel'>{'DRF DATE'}</p>
                                        <p className='detailsRightValue-drf'> {response?.DRF_DATE}</p>
                                    </div>
                                    <div className='col-md-2 mt-3'>
                                        <p className='detailsRightLabel'>{'IFSC'}</p>
                                        <p className='detailsRightValue-drf'> {response?.IFSC_CODE}</p>
                                    </div>
                                    <div className='col-md-2 mt-3'>
                                        <p className='detailsRightLabel'>{'TRANSACTION TYPE'}</p>
                                        <p className='detailsRightValue-drf'> {transType[response?.TRANS_TYPE] ?? response?.TRANS_TYPE}</p>
                                    </div>
                                    <div className='col-md-3 mt-3'>
                                        <p className='detailsRightLabel'>{'BANK BRANCH'}</p>
                                        <p className='detailsRightValue-drf'>  {response?.CR_BANK_BRANCH}</p>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    {!response &&
                        <div className='mt-2'>
                            <div style={{ borderRadius: "5px", width: "100%", border: "1px solid #CBCBCB" }}>
                                <div className='border p-2' style={{ backgroundColor: "#F8F8F8", borderRadius: "5px 5px 0 0 " }}>
                                    <h5>DRF Details</h5>
                                </div>
                                <div className='Error-msg-drf' style={{ 'margin-top': '10px' }}>No DRF Details</div>
                            </div>
                        </div>}
                    {(supResponse) &&
                        <div className='mt-2'>
                            <div style={{ borderRadius: "5px", width: "100%", border: "1px solid #CBCBCB" }}>
                                <div className='border p-2' style={{ backgroundColor: "#F8F8F8", borderRadius: "5px 5px 0 0 " }}>
                                    <h5>Supplier DRF Details</h5>
                                    <div style={{ 'float': 'right', 'margin-top': '-27px' }}>
                                        {checkHasPermission('add-drf') && <button className='btn btn-custom' onClick={toggleModal}>
                                            Edit Supplier DRF
                                        </button>}
                                        {modalState && (
                                            <AddDRFModal
                                                userType={state.userType}
                                                state={modalState}
                                                selectedLender={selectedLender}
                                                toggleModal={toggleModal}
                                                leadId={leadId}
                                                reloadTable={GetDrfDetail}
                                                isMachinerySup={supResponse.is_machinery_sup ?? 0}
                                                mstTransType={transType}
                                                data={supResponse}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className='row p-2'>
                                    <div className='col-md-2'>
                                        <p className='detailsRightLabel'>{'ASSET AMOUNT'}</p>
                                        <p className='detailsRightValue-drf'>{supResponse?.asset_amt}</p>
                                    </div>
                                    <div className='col-md-2'>
                                        <p className='detailsRightLabel'>{'DISBURSED AMOUNT'}</p>
                                        <p className='detailsRightValue-drf'>{supResponse?.finance_amount}</p>
                                    </div>
                                    <div className='col-md-2'>
                                        <p className='detailsRightLabel'>{'BANK ACCOUNT NUMBER'}</p>
                                        <p className='detailsRightValue-drf'> {supResponse?.bank_acc_id}</p>

                                    </div>
                                    <div className='col-md-3'>
                                        <p className='detailsRightLabel'>{'NAME'}</p>
                                        <p className='detailsRightValue-drf'> {supResponse?.acc_name}</p>
                                    </div>
                                    <div className='col-md-3'>
                                        <p className='detailsRightLabel'>{'BANK NAME'}</p>
                                        <p className='detailsRightValue-drf'>  {supResponse?.bank_name}</p>
                                    </div>

                                    <div className='col-md-2 mt-3'>
                                        <p className='detailsRightLabel'>{'DRF DATE'}</p>
                                        <p className='detailsRightValue-drf'> {supResponse?.date}</p>
                                    </div>
                                    <div className='col-md-2 mt-3'>
                                        <p className='detailsRightLabel'>{'IFSC'}</p>
                                        <p className='detailsRightValue-drf'>{supResponse?.ifsc}</p>
                                    </div>
                                    <div className='col-md-2 mt-3'>
                                        <p className='detailsRightLabel'>{'TRANSACTION TYPE'}</p>
                                        <p className='detailsRightValue-drf'> {supResponse?.txn_type}</p>
                                    </div>
                                    <div className='col-md-3 mt-3'>
                                        <p className='detailsRightLabel'>{'SUPPLIER ADDRESS'}</p>
                                        <p className='detailsRightValue-drf'> {supResponse?.address}</p>
                                    </div>
                                    <div className='col-md-3 mt-3'>
                                        <p className='detailsRightLabel'>{'SUPPLIER CITY'}</p>
                                        <p className='detailsRightValue-drf'> {supResponse?.city}</p>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    {(checkHasPermission('add-drf') && isBTCase && [6,9,18,19].includes(cl_lead_lender_status?.id)) ?
                        <div style={{ 'float': 'right', 'margin-top': '7px' }}>
                            {/* {![...btBankCaseResponse, ...btCustomerCaseResponse].some(row=> (row.drf_type == 1 && (row.drf_status == null || row.drf_status == 1))) &&  */}
                                <button className='btn btn-custom' onClick={toggleBtModal}>
                                    Add {selectedLender == 21 ? '' : 'BT '}Bank/Customer DRF
                                </button>
                            {/* } */}
                            {btModalState && (
                                <AddBtDataModal
                                    userType={state.userType}
                                    state={btModalState}
                                    toggleModal={toggleBtModal}
                                    leadId={leadId}
                                    selectedLender={selectedLender} 
                                    reloadTable={GetDrfDetail}
                                    editBtDrf={false}
                                    companyDetails={companyDetails}
                                />
                            )}
                        </div>
                        :
                        null
                    }
                    {(btBankCaseResponse?.length > 0) &&
                        <div style={{ marginTop: "40px" }}>
                            <div style={{ borderRadius: "5px", width: "100%", border: "1px solid #CBCBCB" }}>
                                <div className='border p-2' style={{ backgroundColor: "#F8F8F8", borderRadius: "5px 5px 0 0 " }}>
                                    <h5>{selectedLender == 21 ? '' : 'BT '}Bank DRF Details</h5>
                                </div>
                                <div className="bt_drf_table">
                                    <Table
                                        checkbox={false}
                                        columns={BtCaseColumns}
                                        rows={btBankCaseResponse}
                                        loading={loading}
                                        reloadTable={GetDrfDetail}
                                        editBtDrf={true}
                                        leadStatusId={cl_lead_lender_status.id}
                                    >
                                        {Boolean(!btBankCaseResponse.length && !loading) && <TableNoRecords />}
                                    </Table>
                                </div>
                            </div>
                        </div>}
                    {(btBankCaseResponse.length == 0 && btCustomerCaseResponse.length == 0 && isBTCase) ?
                        <div className='mt-5'>
                            <div style={{ borderRadius: "5px", width: "100%", border: "1px solid #CBCBCB" }}>
                                <div className='border p-2' style={{ backgroundColor: "#F8F8F8", borderRadius: "5px 5px 0 0 " }}>
                                    <h5>{selectedLender == 21 ? '' : 'BT '}Bank DRF Details</h5>
                                </div>
                                <div className='Error-msg-drf' style={{ 'margin-top': '10px' }}>No Bank DRF Details Found</div>
                            </div>
                        </div>
                        :
                        null
                    }
                    {(btCustomerCaseResponse?.length > 0) &&
                        <div style={{ marginTop: "40px" }}>
                            <div style={{ borderRadius: "5px", width: "100%", border: "1px solid #CBCBCB" }}>
                                <div className='border p-2' style={{ backgroundColor: "#F8F8F8", borderRadius: "5px 5px 0 0 " }}>
                                    <h5>{selectedLender == 21 ? '' : 'BT '}Customer DRF Details</h5>
                                </div>
                                <div className="bt_drf_table">
                                    <Table
                                        checkbox={false}
                                        columns={BtCaseColumns}
                                        rows={btCustomerCaseResponse}
                                        loading={loading}
                                        reloadTable={GetDrfDetail}
                                        editBtDrf={true}
                                        leadStatusId={cl_lead_lender_status.id}
                                    >
                                        {Boolean(!btCustomerCaseResponse.length && !loading) && <TableNoRecords />}
                                    </Table>
                                </div>
                            </div>
                        </div>}
                </>
            }
        </>
    )
}

export default DRF